// import landingBG from '../../../assets/image/GUTFIT-LANDING-banner.jpg';
import styles from './admin-dashboard.module.scss';

export const AdminDashboard = () => {
  return (
    <>
      <div className={styles['admin-dashboard-container']}>{/* <img src={landingBG} alt="Landing" /> */}</div>
    </>
  );
};
